<template>
    <div>
        <template v-if="orders.length && streamUrl">
            <v-container style="display: none;">
                <v-col cols="12">
                    <v-row justify="center">
                        <v-col cols="auto" style="min-height: 240px;">
                            <v-img height="300" :src="streamUrl"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-container>
        </template>
        <template v-else>
            <v-carousel
                class="promo-carousel"
                cycle
                height="300"
                :hide-delimiters="!isMobile"
                :show-arrows="!isMobile"
                delimiter-icon="$delimiter"
                hide-delimiter-background
            >
                <template v-slot:prev="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="#DA251C"/>
                            <path d="M14.969 20.5305L22.469 28.0305C22.5386 28.1002 22.6214 28.1555 22.7124 28.1932C22.8035 28.2309 22.901 28.2503 22.9996 28.2503C23.0981 28.2503 23.1957 28.2309 23.2868 28.1932C23.3778 28.1555 23.4605 28.1002 23.5302 28.0305C23.5999 27.9608 23.6552 27.8781 23.6929 27.787C23.7306 27.696 23.75 27.5984 23.75 27.4999C23.75 27.4013 23.7306 27.3037 23.6929 27.2127C23.6552 27.1217 23.5999 27.0389 23.5302 26.9692L16.5599 19.9999L23.5302 13.0305C23.6709 12.8898 23.75 12.6989 23.75 12.4999C23.75 12.3008 23.6709 12.11 23.5302 11.9692C23.3895 11.8285 23.1986 11.7495 22.9996 11.7495C22.8006 11.7495 22.6097 11.8285 22.469 11.9692L14.969 19.4692C14.8992 19.5389 14.8439 19.6216 14.8062 19.7127C14.7684 19.8037 14.749 19.9013 14.749 19.9999C14.749 20.0984 14.7684 20.196 14.8062 20.2871C14.8439 20.3781 14.8992 20.4608 14.969 20.5305Z" fill="white"/>
                        </svg>

                    </v-btn>
                </template>
                <template v-slot:next="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#DA251C"/>
                            <path d="M25.031 20.5305L17.531 28.0305C17.4614 28.1002 17.3786 28.1555 17.2876 28.1932C17.1965 28.2309 17.099 28.2503 17.0004 28.2503C16.9019 28.2503 16.8043 28.2309 16.7132 28.1932C16.6222 28.1555 16.5395 28.1002 16.4698 28.0305C16.4001 27.9608 16.3448 27.8781 16.3071 27.787C16.2694 27.696 16.25 27.5984 16.25 27.4999C16.25 27.4013 16.2694 27.3037 16.3071 27.2127C16.3448 27.1217 16.4001 27.0389 16.4698 26.9692L23.4401 19.9999L16.4698 13.0305C16.3291 12.8898 16.25 12.6989 16.25 12.4999C16.25 12.3008 16.3291 12.11 16.4698 11.9692C16.6105 11.8285 16.8014 11.7495 17.0004 11.7495C17.1994 11.7495 17.3903 11.8285 17.531 11.9692L25.031 19.4692C25.1008 19.5389 25.1561 19.6216 25.1938 19.7127C25.2316 19.8037 25.251 19.9013 25.251 19.9999C25.251 20.0984 25.2316 20.196 25.1938 20.2871C25.1561 20.3781 25.1008 20.4608 25.031 20.5305Z" fill="white"/>
                        </svg>

                    </v-btn>
                </template>
                <v-carousel-item
                    v-for="(promotion, i) in promotionsList"
                    :key="i"
                    :src="promotion.imageUrl"
                    :to="{name: 'PromoDetail', params: {promotionId: promotion.id}}"
                />
            </v-carousel>
        </template>

        <template v-if="isMobile">
            <v-btn
                color="secondary"
                class="mt-4 mx-2 order-btn"
                :to="{ name: 'StationOnlineOrder' }"
            >
                Записаться
            </v-btn>
        </template>
        <div class="history-block mt-10" v-if="orders.length">
            <div>
                <div class="order-history-header">
                    <div class="order-history-header-title">
                        Ваши записи
                    </div>
                    <div>
                        <router-link :to="{name: 'History'}" class="to-all-history">
                            <span v-if="isMobile">Посмотреть все</span>
                            <span v-else>Перейти в историю ремонта</span>
                            ({{ orders.length }})
                        </router-link>
                    </div>
                </div>
                <template v-if="this.$vuetify.breakpoint.smAndDown">
                    <div
                        v-for="carHistoryItem in orders"
                        :key="carHistoryItem.id"
                    >
                        <OrderHistoryItem :order="carHistoryItem" withCar :car="carState.cars[carHistoryItem.carId]" withoutComment withCancelBtn />
                    </div>
                </template>
                <template v-else>
                    <!-- isMobile = false -->
                    <div class="history-table-header mt-10 d-flex px-6 font-weight-bold">
                        <div class="pr-2" style="width: 12%">Дата и время</div>
                        <div class="px-2" style="width: 20%">Номер документа</div>
                        <div class="px-2" style="width: 20%">Автомобиль</div>
                        <div class="px-2" style="width: 40%">Список услуг</div>
                        <!-- <div class="px-2" style="width: 13%">Цена</div> -->
                        <div></div>
                    </div>
                    <div
                        v-for="(carHistoryItem, index) in orders"
                        :key="carHistoryItem.id"
                    >
                        <OrderHistoryItem :order="carHistoryItem" withCar :car="carState.cars[carHistoryItem.carId]" withoutComment withCancelBtn />
                        <v-divider v-if="index !== orders.length - 1" class="mt-2"/>
                    </div>
                </template>
            </div>
        </div>
        <div class="history-block mt-10">
            <div>
                <div class="order-history-header">
                    <div class="order-history-header-title">
                        История ремонта
                    </div>
                    <div>
                        <router-link :to="{name: 'History'}" class="to-all-history">
                            <span v-if="isMobile">Посмотреть все</span>
                            <span v-else>Перейти в историю ремонта</span>
                            ({{ carHistory.length }})
                        </router-link>
                    </div>
                </div>
                <template v-if="this.$vuetify.breakpoint.smAndDown">
                    <div
                        v-for="carHistoryItem in visibleCarHistory"
                        :key="carHistoryItem.id"
                    >
                        <OrderHistoryItem :order="carHistoryItem" withCar :car="carState.cars[carHistoryItem.carId]" withoutComment/>
                    </div>
                </template>
                <template v-else>
                    <!-- isMobile = false -->
                    <div class="history-table-header mt-10 d-flex px-6 font-weight-bold">
                        <div class="pr-2" style="width: 12%">Дата и время</div>
                        <div class="px-2" style="width: 20%">Номер документа</div>
                        <div class="px-2" style="width: 20%">Автомобиль</div>
                        <div class="px-2" style="width: 40%">Список услуг</div>
                        <!-- <div class="px-2" style="width: 13%">Цена</div> -->
                        <div></div>
                    </div>
                    <div
                        v-for="(carHistoryItem, index) in visibleCarHistory"
                        :key="carHistoryItem.id"
                    >
                        <OrderHistoryItem :order="carHistoryItem" withCar :car="carState.cars[carHistoryItem.carId]" withoutComment/>
                        <v-divider v-if="index !== carHistory.length - 1" class="mt-2"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import OrderHistoryItem from '@/components/app/personal/order/OrderHistoryItem'

    export default {
        name: 'StationScreen',

        components: {
            OrderHistoryItem,
        },

        computed: {
            ...mapState('car', {
                carState: state => state,
            }),

            ...mapGetters({
                orders: 'order/getOrders',
                promotions: 'promotion/getPromotions',
                carHistory: 'carHistory/getCarHistory',
            }),

            visibleCarHistory() {
                return this.carHistory.slice(0, 3)
            },

            streamUrl() {
                for (const order of this.orders) {
                    const streamUrl = order.getStreamUrl()

                    if (streamUrl) {
                        return streamUrl
                    }
                }

                return null
            },

            promotionsList() {
                const promotions = [
                    // {
                    //     id: 999999999,
                    //     imageUrl: require('@/assets/carousel/image1.png'),
                    // }, // TODO: remove
                    ...this.promotions]
                return promotions
            },

            isMobile() {
                return this.$vuetify.breakpoint.smAndDown
            },
        },

        mounted() {
            this.$store.dispatch('order/fetch')
            if (!this.carHistory.length) {
                this.$store.dispatch('carHistory/fetch')
            }
        },
    }
</script>

<style>
    .promo-carousel .v-carousel__controls .v-carousel__controls__item.v-btn {
        color: #3fab3e !important;
    }
    .order-history-header {
        display: flex;
        align-items: center;
        /* justify-content: space-between; */
        padding: 10px 20px;
    }
    .mobile .order-history-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
    }
    .order-history-header-title {
        font-size: 22px;
        font-weight: 600;
    }
    .mobile .order-history-header-title {
        font-size: 20px;
    }
    .to-all-history {
        font-size: 14px;
        color: #DA251C !important;
        margin-left: 14px;
    }
    .order-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 2px solid #DA251C !important;
        background: #DA251C !important;
        /* width: 253px; */
        height: 52px;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        /* width: 100% !important; */
    }
</style>
